import React from 'react';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { GenericDivider } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { OutcomeTile } from 'web-ui-components/lib/layout/content';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';

const ApplicationCompletePage = ({ saveApplicationCompleteForm, bankId }) => (
  <Form
    onSubmit={saveApplicationCompleteForm}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <Content>
          {({
            applicationCompletePageTitle = '',
            applicationCompleteHeading1,
            applicationCompleteListItem1a,
            applicationCompleteListItem1b,
            applicationCompleteHeading2,
            applicationCompleteListItem2a,
            applicationCompleteListItem2b,
            applicationCompleteHeading3,
            applicationCompleteListItem3a,
            applicationCompleteListItem3b,
            applicationCompleteListItem3c,
            applicationCompleteListItem3d,
            applicationCompleteHeading5,
            applicationCompleteListItem5a,
            applicationCompleteSubmit
          }) => (
            <div>
              <div>
                <OutcomeTile.Success headingText={applicationCompletePageTitle} />
                <GenericDivider />
                <StandardBody>
                  <SectionHeading>{applicationCompleteHeading1}</SectionHeading>
                  <BulletList
                    items={[applicationCompleteListItem1a, applicationCompleteListItem1b]}
                  />
                  <SectionHeading>{applicationCompleteHeading2}</SectionHeading>
                  <BulletList
                    items={[applicationCompleteListItem2a, applicationCompleteListItem2b]}
                  />
                  <SectionHeading>{applicationCompleteHeading3}</SectionHeading>
                  <BulletList
                    items={[
                      applicationCompleteListItem3a,
                      applicationCompleteListItem3b,
                      applicationCompleteListItem3c,
                      applicationCompleteListItem3d
                    ]}
                  />
                  <SectionHeading>{applicationCompleteHeading5}</SectionHeading>
                  <BulletList items={[applicationCompleteListItem5a]} />
                </StandardBody>
              </div>
              <Submit hideExit submitButtonText={applicationCompleteSubmit} />
            </div>
          )}
        </Content>
      </form>
    )}
  />
);

ApplicationCompletePage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveApplicationCompleteForm: PropTypes.func.isRequired
};

export default ApplicationCompletePage;
